//BootstrapStarterBodyUtilities.jsx
import { useEffect } from 'react';

export const useToolToggleListeners = (setVisibleTool) => {
    useEffect(() => {
        const handleToggle = (tool) => () => {
            setVisibleTool(prev => prev === tool ? null : tool);
        };

        const listeners = {
            toggleViewsTool: handleToggle('views'),
            toggleTagsTool: handleToggle('tags'),
            toggleStylesTool: handleToggle('styles'),
            toggleFiltersTool: handleToggle('filters'),
            toggleMainMenuTool: handleToggle('mainmenu'),
        };

        Object.entries(listeners).forEach(([event, handler]) => {
            window.addEventListener(event, handler);
        });

        return () => {
            Object.entries(listeners).forEach(([event, handler]) => {
                window.removeEventListener(event, handler);
            });
        };
    }, [setVisibleTool]);
};

export const useClickOffMainMenu = (visibleTool, setVisibleTool) => {
    useEffect(() => {
        const handler = (event) => {
            const mainMenu = document.getElementById('appBodyToolMainMenu');
            const clickedInside = mainMenu &&
                !mainMenu.classList.contains('d-none') &&
                mainMenu.contains(event.target);

            if (!clickedInside && visibleTool === 'mainmenu') {
                setVisibleTool(null);
            }
        };

        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [visibleTool, setVisibleTool]);
};

export const useClickOffMobileTools = (visibleTool, setVisibleTool) => {
    useEffect(() => {
        const handler = (event) => {
            if (window.innerWidth >= 768) return;

            const ids = ['Views', 'Tags', 'Styles', 'Filters'];
            const clickedInside = ids.some(id => {
                const el = document.getElementById(`appBodyTool${id}`);
                return el && !el.classList.contains('d-none') && el.contains(event.target);
            });

            if (!clickedInside && ['views', 'tags', 'styles', 'filters'].includes(visibleTool)) {
                setVisibleTool(null);
            }
        };

        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [visibleTool, setVisibleTool]);
};

export const handleReturnToTop = (containerRef) => {
    if (containerRef.current) {
        // Scroll the container itself
        containerRef.current.scrollTo({
            top: 0,
            behavior: 'smooth',
        });

        // Optionally scroll any child that also scrolls
        const innerScrollable = containerRef.current.querySelector('.scrollable-inner');
        if (innerScrollable) {
            innerScrollable.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
    }
};

export const handleScrollToBottom = (containerRef) => {
    if (containerRef.current) {
        // Scroll the container itself to the bottom
        containerRef.current.scrollTo({
            top: containerRef.current.scrollHeight,
            behavior: 'smooth',
        });

        // Optionally scroll any child that also scrolls
        const innerScrollable = containerRef.current.querySelector('.scrollable-inner');
        if (innerScrollable) {
            innerScrollable.scrollTo({
                top: innerScrollable.scrollHeight,
                behavior: 'smooth',
            });
        }
    }
};



export const hideAllTools = (visibleTool, setVisibleTool) => {
    if (visibleTool !== null) {
        console.log(`Hiding visible tool: ${visibleTool}`);
        setVisibleTool(null);
    }
};

export const hideMainMenu = (setVisibleTool) => {
    const mainMenu = document.getElementById('appBodyToolMainMenu');
    if (mainMenu && !mainMenu.classList.contains('d-none')) {
        console.log('hideMainMenu: Hiding main menu');
        setVisibleTool(null);
    } else {
        console.log('hideMainMenu: Main menu already hidden');
    }
};
